import {useTranslation} from 'react-i18next';
import {AppScreen} from './AppScreen';
import {Logo} from './Logo';
import {Headline} from './Headline';
import {ProfileForm} from './ProfileForm';
import './ProfileScreen.css';

export const ProfileScreen = (props) => {
  const {t} = useTranslation();

  return (
    <AppScreen className="ProfileScreen">
      <Logo/>
      <Headline>{t('ProfileScreen.headline')}</Headline>
      <ProfileForm userId={props.userId}/>
    </AppScreen>
  );
};

export default ProfileScreen;
